export default {
  BASE_URL: '/fm/invoice/order',
  api: [
    {
      name: 'list',
      desc: '列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '明细',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'export',
      desc: '导出明细',
      method: 'GET',
      path: '/export'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/outputInvoice/unbilled.js